import { MessageSeverity } from '../../enums/message-severity.enum';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { CustomMessageGroup } from './custom-message-group';

/**
 * Configuration for a CustomLog task.
 * Writes a log message at a configurable severity. Supports conditional
 * message overrides via messageHandlers.
 */
export class CustomLogConfig extends DestinationTaskConfigBase {
	/** Default log severity. Error=1, Warning=2, Info=3, Debug=4. */
	messageSeverity?: MessageSeverity;
	/** Default log message text. Supports {{fieldName}} template references. */
	customMessage?: string;
	/** Optional conditional override rules. Each handler evaluates a condition and overrides the default message/severity when matched. @default [] */
	messageHandlers: CustomMessageGroup[] = [];

	constructor(init?: Partial<CustomLogConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
